import React, { useState } from 'react';

const Accordion = ({children, title, defaultOpen = true}, props) => {
    const [isActive, setIsActive] = useState(defaultOpen);

    const images = {
        arrow: require('shared_img/icons/accordion-arrow.svg'),
    };

    const titleClasses = ['accordion-title'];

    if (isActive) {
        titleClasses.push('active');
    }

    return (
        <div className="accordion-item">
            <div className={titleClasses.join(' ')} onClick={() => setIsActive(!isActive)}>
                <div>{title}</div>
                <div className={'arrow'}><img src={images.arrow} alt=""/></div>
            </div>
            {isActive && <div className="accordion-content">{children}</div>}
        </div>
    );
};

export default Accordion;